import { render, staticRenderFns } from "./ReportBasicSetting.vue?vue&type=template&id=6af4c5f4&scoped=true"
import script from "./ReportBasicSetting.vue?vue&type=script&lang=js"
export * from "./ReportBasicSetting.vue?vue&type=script&lang=js"
import style0 from "./ReportBasicSetting.vue?vue&type=style&index=0&id=6af4c5f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af4c5f4",
  null
  
)

export default component.exports